/**
 * Blocks generic PATCH of money-lifecycle fields.
 * Cancel flows may still PATCH status to a cancelled value (backend unmatches).
 */

const FINANCIAL_AMOUNT_FIELDS = new Set([
  "transfer_amount",
  "allocated_amount",
  "unallocated_amount",
  "slip_matched_amount",
  "total_amount",
  "amount",
  "vat",
]);

const CANCEL_STATUS_PATTERN = /(ยกเลิก|cancel)/i;

export function isFinancialAmountField(field: string): boolean {
  return FINANCIAL_AMOUNT_FIELDS.has(field);
}

export function isCancelStatusValue(value: unknown): boolean {
  return CANCEL_STATUS_PATTERN.test(String(value ?? ""));
}

/** True when this patch must be rejected by the generic write path. */
export function isBlockedFinancialPatch(field: string, value: unknown): boolean {
  if (isFinancialAmountField(field)) return true;
  if (field === "status" && !isCancelStatusValue(value)) return true;
  return false;
}

export function assertFinancialPatchAllowed(field: string, value: unknown): void {
  if (!isBlockedFinancialPatch(field, value)) return;
  if (isFinancialAmountField(field)) {
    throw new Error("ไม่สามารถแก้จำนวนเงินผ่านการแก้ไขทั่วไปได้");
  }
  throw new Error("ไม่สามารถเปลี่ยนสถานะเงินผ่านการแก้ไขทั่วไปได้");
}
